import "../styles/main.css";
import filter from "../assets/DottedFilter.webp";
import { Link } from "react-router-dom";
const Joinus = () => {
  return (
    <div className="relative w-full py-20 sm:px-4 sm:py-14 bg-[#FFF528] flex flex-col overflow-hidden">
<div className="absolute inset-0 ">
  <img src={filter} className="w-full h-full object-cover" />
</div>

      <div className=" z-10 flex flex-col items-center justify-center text-center">
        <h1
          style={{ fontFamily: "Norwester" }}
          className="text-[96px] xl:text-[48px] lg:text-[38px] md:text-3xl sm:text-2xl mb-5"
        >
          Join us now
        </h1>
        <h1
          style={{ fontFamily: "Norwester" }}
          className="text-[50px] xl:text-[30px] md:text-2xl sm:text-xl leading-snug xl:leading-[80px] lg:leading-[80px]  sm:leading-10 md:leading-10"
        >
          Be Part of the Revolution in Sports Broadcasting
        </h1>
        <p className="font-league-spartan text-[28px] xl:text-[18px] md:text-base sm:text-sm text-black text-center xl:max-w-2xl mx-auto leading-relaxed">
          Take the first step towards transforming how sports stories are told
          and experienced.
        </p>
        <p className="font-league-spartan text-[32px] xl:text-[18px] md:text-base sm:text-sm text-black text-center max-w-4xl xl:max-w-2xl mx-auto leading-relaxed">
          Join vupop today, and contribute to a community that values
          authenticity and rewards Fans for their vupop content
        </p>
      </div>
      <div className="flex md:flex-row sm:gap-2 z-50 gap-10 items-center justify-center mt-10">
        <div className="w-[50%] flex flex-col justify-end">
          <h1
            style={{ fontFamily: "Norwester" }}
            className="text-[50px] xl:text-3xl md:text-2xl sm:text-lg leading-snug text-right md:text-center"
          >
            For Fans
          </h1>

          <div className="sm:px-4 mt-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"

            >
            <button className="w-full text-[28px] xl:text-[16px] sm:text-sm bg-black h-[56px] text-[#FFF528] items-center font-league-spartan  text-center sm:pl-1 sm:pr-1">
              Download the vupop now
            </button>
            </a>
          </div>
        </div>

        <div className="w-[50%] flex flex-col justify-start">
          {/* <h1 style={{ fontFamily: 'Norwester' }} className='text-[64px] text-center text-black mb-6 xl:text-[64px]  lg:text-5xl sm:text-lg md:text-2xl w-[100%] xl:w-[100%] lg:w-[100%] md:w-[80%] sm:w-[82%] font-medium leading-[90px] xl:leading-[80px] lg:leading-[80px]  sm:leading-10 md:leading-10'>*/}
          <h1
            style={{ fontFamily: "Norwester" }}
            className="text-[50px] xl:text-3xl md:text-2xl sm:text-lg leading-snug text-leftt md:text-center"
          >
            For Broadcasters
          </h1>
          <div className="sm:px-4 mt-3">
             <Link to="https://manager.vupop.io/broadcaster/signup/subscription" target="_blank">
            <button className="w-full text-[28px] xl:text-[16px] sm:text-sm bg-black h-[56px] text-[#FFF528] items-center font-league-spartan  text-center sm:pl-2 sm:pr-2">
             Register Now
            </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Joinus;
